<template>
    <div class="p-[16px]">
        <button v-on:click="pushback" class="text-[12px] mb-[8px] pr-4 py-2 text-[#2b2b2b] font-light rounded-lg hover:bg-gray-100 flex items-center gap-x-[12px]">
            <ArrowLeft :size="16" strokeWidth="1.3"/>
            Retourner à la liste
        </button>
        <div class="mb-[16px] flex items-center justify-between">
            <h2 class="text-[18px] text-[#2b2b2b] font-light">Ajouter un collaborateur</h2>
        </div>
        <div class="p-[8px] mb-[16px] rounded-xl bg-[#fff3ea] text-[#bf6d2e] font-light">
            <p class="text-[12px]">Les chanmps suivis d'un (*) sont obligatoires</p>
        </div>

        <div class="flex items-start gap-x-[36px] p-[16px] text-[#2b2b2b]">
            <div class="w-[55%]">
                <div>
                    <Transition
                        @enter="onEnter"
                        @leave="onLeave"
                        :css="false" 
                    >
                        <div v-if="step == 1">
                            <h2 class="text-[16px]">
                                Informations d'identification de l'employé
                            </h2>
                            <p class="font-light text-[12px]">Saisissez les données d'état civil essentielles du collaborateur (Nom, Prénom, Date de Naissance, Nationalité) pour son dossier administratif.</p>
                            <div class="mt-[20px]">
                                <div class="w-full flex flex-col items-start ">
                                    <label for="name" class="font-light" >Nom<span class="text-[#f44545]">*</span></label>
                                    <input type="text" v-model="userdata.first_name" name="name" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none" placeholder="John">
                                </div>

                                <div class="w-full flex flex-col items-start mt-[8px]">
                                    <label for="lastname" class="font-light" >Prenom<span class="text-[#f44545]">*</span></label>
                                    <input type="text" placeholder="Doe" v-model="userdata.last_name" name="lastname" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none">
                                </div>

                                <!-- <div class="w-full flex flex-col items-start mt-[8px]">
                                    <label for="tel" class="font-light" >Contact<span class="text-[#f44545]">*</span></label>
                                    <input type="tel" placeholder="(+XXX) XXX XXX XXXX" v-model="userdata.phone" name="tel" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none">
                                </div> -->

                                <div class="w-full flex items-center justify-between mt-[8px] text-black">
                                    <div class="w-[49%] flex flex-col items-start ">
                                        <label for="sexe" class="font-light" >Sexe<span class="text-[#f44545]">*</span></label>
                                        <select v-model="userdata.sexe" name="sexe" id="contrat" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none">
                                            <option value="">Choisissez le sexe</option>
                                            <option value="M">Masculin</option>
                                            <option value="F">Féminin</option>
                                        </select>
                                    </div>

                                    <div class="w-[49%] flex flex-col items-start ">
                                        <label for="daten" class="font-light" >Date de naissance<span class="text-[#f44545]">*</span></label>
                                        <input type="date" placeholder="" v-model="userdata.birthdate" name="daten" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none">
                                    </div>
                                </div>

                                <div class="w-full flex flex-col items-start mt-[8px]">
                                    <label for="mail" class="font-light" >Email<span class="text-[#f44545]">*</span></label>
                                    <input type="email" v-model="userdata.email" name="name" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none" placeholder="john@gmail.com">
                                </div>

                                <div class="w-full flex flex-col items-start mt-[8px]">
                                    <label for="sitmat" class="font-light" >Situation matrimonial<span class="text-[#f44545]">*</span></label>
                                    <select v-model="userdata.marital_status" name="sitmat" id="sitmat" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none">
                                        <option value="">Choisissez le status</option>
                                        <option value="celibataire">Célibataire</option>
                                        <option value="marie">Marié</option>
                                        <option value="veuve">Veuve</option>
                                        <option value="divorce">Divorcé</option>
                                    </select>
                                </div>

                                <div class="w-full flex flex-col items-start mt-[8px]">
                                    <label for="nbenfant" class="font-light" >Nombre d'enfant<span class="text-[#f44545]">*</span></label>
                                    <input type="number" placeholder="00" min="0" v-model="userdata.children_nb" name="nbenfant" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none">
                                </div>

                                <div class="w-full flex flex-col items-start mt-[8px]">
                                    <label for="nationality" class="font-light" >Nationalité<span class="text-[#f44545]">*</span></label>
                                    <select v-model="userdata.nationality" name="nationality" id="nationality" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none">
                                        <option value="">Choisissez la nationalité</option>
                                        <option v-for="value in nationalityOptions" :key="value.value" :value="value.value">
                                            {{ value.label }}
                                        </option>
                                    </select>
                                </div>

                            </div>
                            <div class="h-[100px] w-full"/>
                        </div>
                        <div v-else-if="step == 2">
                            <h2 class="text-[16px]">
                                Affectation et organisation
                            </h2>
                            <p class="font-light text-[12px]">Définissez les détails du poste : intitulé exact, service d'affectation, manager direct, et toute information relative à son organisation dans l'entreprise.</p>
                            <div class="mt-[20px]">
                                <div class="w-full flex flex-col items-start ">
                                    <label for="Matricule" class="font-light" >Matricule<span class="text-[#f44545]">*</span></label>
                                    <input type="text" v-model="userdata.matricule" name="Matricule" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none" placeholder="XXXXXXXX">
                                </div>
                                <div class="w-full mt-[8px] flex flex-col items-start ">
                                    <label for="Département" class="font-light" >Profil<span class="text-[#f44545]">*</span></label>
                                    <select v-model="profildata.profile_id" name="Département" id="Département" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none">
                                        <option value="">Choisissez le profil</option>
                                        <option v-for="value in profils" :key="value.id" :value="value.id">{{ value.label }}</option>
                                    </select>
                                </div>
                                <div class="w-full mt-[8px] flex flex-col items-start ">
                                    <label for="pro" class="font-light" >Poste<span class="text-[#f44545]">*</span></label>
                                    <input type="text" placeholder="" v-model="profildata.job_name" name="pro" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none">
                                </div>
                                <div class="w-full flex flex-col items-start ">
                                    <label for="shift" class="font-light" >Horaire<span class="text-[#f44545]">*</span></label>
                                    <select v-model="userdata.shift" name="shift" id="shift" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none">
                                        <option v-for="shift in shifts" :key="shift.id" :value="shift.symbol">{{ shift.label }} : {{ shift.hour_start }} - {{ shift.hour_end }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="h-[100px] w-full"/>
                        </div>
                        <div v-else-if="step == 3">
                            <h2 class="text-[16px]">
                                Détails du contrat de travail
                            </h2>
                            <p class="font-light text-[12px]">Renseignez les modalités légales et financières du recrutement : type de contrat (CDI/CDD), date de début, statut, classification et rémunération.</p>
                            <div class="mt-[20px]">
                                <div class="w-full flex flex-col items-start ">
                                    <label for="cont" class="font-light" >Type de contrat<span class="text-[#f44545]">*</span></label>
                                    <select v-model="profildata.contract_type" name="cont" id="cont" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none">
                                        <option value="STAGE">STAGE</option>
                                        <option value="CDD">CDD</option>
                                        <option value="CDI">CDI</option>
                                        <option value="CONSULTANT">CONSULTANT</option>
                                    </select>
                                </div>

                                <div class="w-full flex items-start justify-between mt-[8px]">
                                    <div class="w-[49%] flex flex-col items-start ">
                                        <label for="Fin" class="font-light" >Début<span class="text-[#f44545]">*</span></label>
                                        <input type="date" v-model="profildata.start" name="Fin" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none" placeholder="">
                                    </div>

                                    <div class="w-[49%] flex flex-col items-start">
                                        <label for="Fin" class="font-light" >Fin<span class="text-[#f44545]">*</span></label>
                                        <input type="date" v-model="profildata.end" name="Fin" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none" placeholder="">
                                    </div>
                                </div>

                                <div class="w-full flex flex-col items-start mt-[8px]">
                                    <label for="base_salary" class="font-light" >Salaire de base<span class="text-[#f44545]">*</span></label>
                                    <input type="number" min="0" v-model="profildata.salary" name="base_salary" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none">
                                </div>

                                <div class="w-full flex flex-col items-start mt-[8px]">
                                    <label for="SurSalaire" class="font-light" >SurSalaire<span class="text-[#f44545]">*</span></label>
                                    <input type="number" min="0" v-model="profildata.sursalaire" name="SurSalaire" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none">
                                </div>

                                <div class="w-full flex items-start justify-between mt-[8px]">
                                    <div class="w-[49%] flex flex-col items-start">
                                        <label for="transport" class="font-light" >Prime de transport</label>
                                        <input type="number" min="0" v-model="profildata.prime_tp" name="transport" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none">
                                    </div>

                                    <div class="w-[49%] flex flex-col items-start">
                                        <label for="respon" class="font-light" >Prime de responsabilité</label>
                                        <input type="number" min="0" v-model="profildata.prime_respo" name="respon" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none">
                                    </div>
                                </div>

                                <div class="w-full flex items-start justify-between mt-[8px]">
                                    <div class="w-[49%] flex flex-col items-start">
                                        <label for="spe" class="font-light" >Prime de spéciale</label>
                                        <input type="number" min="0" v-model="profildata.prime_speciale" name="spe" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none">
                                    </div>

                                    <div class="w-[49%] flex flex-col items-start">
                                        <label for="logement" class="font-light" >Prime de logement</label>
                                        <input type="number" min="0" v-model="profildata.prime_logement" name="logement" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none">
                                    </div>
                                </div>

                            </div>
                            <div class="h-[100px] w-full"/>
                        </div>
                        <div v-else>
                            <h2 class="text-[16px]">
                                Coordonnées et contact d'urgence
                            </h2>
                            <p class="font-light text-[12px]">Enregistrez l'adresse postale, les numéros de téléphone et l'e-mail professionnel/personnel. N'oubliez pas le contact d'urgence en cas de besoin.</p>
                            <div class="mt-[20px]">
                                <div class="w-full mt-[8px] flex flex-col items-start ">
                                    <label for="tel" class="font-light" >Contact<span class="text-[#f44545]">*</span></label>
                                    <input type="tel" placeholder="0088776655" v-model="userdata.phone" name="tel" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none">
                                </div>

                                <div class="w-full mt-[8px] flex flex-col items-start ">
                                    <label for="Adresse" class="font-light" >Adresse<span class="text-[#f44545]">*</span></label>
                                    <input type="text" placeholder="Ci" v-model="userdata.address" name="Adresse" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none">
                                </div>

                                <div class="w-full flex items-start justify-between mt-[8px]">
                                        <div class="w-[49%] flex flex-col items-start ">
                                            <label for="cnps" class="font-light" >Numéro Cnps<span class="text-[#f44545]">*</span></label>
                                            <input type="text" v-model="userdata.n_cnps" name="name" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none" placeholder="">
                                        </div>

                                        <div class="w-[49%] flex flex-col items-start ">
                                            <label for="rib" class="font-light" >Rib<span class="text-[#f44545]">*</span></label>
                                            <input type="text" placeholder="" v-model="userdata.rib" name="rib" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none">
                                        </div>
                                </div>

                                <div class="w-full flex items-start justify-between mt-[8px]">
                                        <div class="w-[49%] flex flex-col items-start ">
                                            <label for="swift" class="font-light" >Swift<span class="text-[#f44545]">*</span></label>
                                            <input type="text" v-model="userdata.swift" name="swift" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none" placeholder="">
                                        </div>

                                        <div class="w-[49%] flex flex-col items-start ">
                                            <label for="banque" class="font-light" >Banque<span class="text-[#f44545]">*</span></label>
                                            <input type="text" placeholder="" v-model="userdata.bank" name="banque" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none">
                                        </div>
                                </div>

                                <div class="w-full flex items-start justify-between mt-[8px]">
                                        <div class="w-[49%] flex flex-col items-start ">
                                            <label for="urgence" class="font-light" >Contacte cas d'urgence<span class="text-[#f44545]">*</span></label>
                                            <input type="tel" v-model="userdata.emergency_phone" name="urgence" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none" placeholder="0000000000">
                                        </div>

                                        <div class="w-[49%] flex flex-col items-start ">
                                            <label for="local" class="font-light" >Local ou expatrié<span class="text-[#f44545]">*</span></label>
                                            <select v-model="profildata.employee_status" name="local" id="local" class="h-[40px] w-full rounded-xl border outline-none p-3 focus:outline-none">
                                                <option value="LOCAL">LOCAL</option>
                                                <option value="EXPATRIÉ">EXPATRIÉ</option>
                                            </select>
                                        </div>
                                </div>
                            </div>
                        </div>
                    </Transition>
                </div>
                <div class="fixed bottom-0 right-0 px-[16px] app-width bg-white z-[200] text-black border-t mt-[16px] py-[8px] flex items-center justify-between">
                    <button v-on:click="prev" :disabled="step == 1" class="h-[35px] px-[12px] rounded-xl border font-light flex items-center gap-x-[6px]">
                        <ArrowLeft :size="16" strokeWidth="1.3"/>
                        Retour
                    </button>

                    <button :disabled="load" v-on:click="skip" class="h-[35px] px-[12px] bg-[#3c41e9] text-white rounded-xl font-light flex items-center gap-x-[6px]">
                        {{step == 4 ? "Enregistré" : "Continuer"}}
                        <Transition
                            @enter="onEnter"
                            @leave="onLeave"
                            :css="false" 
                        >
                        <ArrowRight v-if="step != 4" :size="16" strokeWidth="1.3"/>
                        <Loader2 v-else :size="16" strokeWidth="1.3" :class="{'animate-spin':load}"/>
                    </Transition>
                    </button>
                </div>
            </div>
            <div class="w-[40%] p-[16px] flex flex-col items-start">

                <div class="h-[50px] relative">
                    <div class="flex items-center gap-x-[16px]">
                        <div class="size-[20px] rounded-full bg-[#3c41e9]"/>
                        <p>Identité</p>
                    </div>
                    <div class="absolute top-[26px] left-0 w-[10px] h-[14px] border-r border-r-[#3c41e9] border-dashed"/>
                </div>

                <div class="h-[50px] relative">
                    <div class="flex items-center gap-x-[16px]">
                        <div :class="['size-[20px] rounded-full border',{'bg-[#3c41e9] border-none':step >= 2}]"/>
                        <p>Poste</p>
                    </div>
                    <div :class="['absolute top-[26px] left-0 w-[10px] h-[14px] border-r border-dashed',{'border-r-[#3c41e9]':step >= 2}]"/>
                </div>

                <div class="h-[50px] relative">
                    <div class="flex items-center gap-x-[16px]">
                        <div :class="['size-[20px] rounded-full border',{'bg-[#3c41e9] border-none':step >= 3}]"/>
                        <p>Contrat</p>
                    </div>
                    <div :class="['absolute top-[26px] left-0 w-[10px] h-[14px] border-r border-dashed',{'border-r-[#3c41e9]':step >= 3}]"/>
                </div>

                
                <div class="flex items-center gap-x-[16px]">
                    <div :class="['size-[20px] rounded-full border',{'bg-[#3c41e9] border-none':step == 4}]"/>
                    <p>Coordonnées</p>
                </div>

            </div>
        </div>

        <!-- <div class="bg-white rounded-lg px-4 py-6 mb-3 text-[#2b2b2b] flex flex-col items-center">
            
            <div class="flex flex-col items-center w-[65%]">
                <h3 class="w-full underline mt-8 mb-4 text-[20px] font-light">Identité & Coordonnées</h3>
                <div class="w-full flex items-center justify-between px-6 pt-4 text-black">
                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="name" class="font-light" >Nom<span class="text-[#f44545]">*</span></label>
                            <input type="text" v-model="userdata.first_name" name="name" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none" placeholder="John">
                        </div>

                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="lastname" class="font-light" >Prenom<span class="text-[#f44545]">*</span></label>
                            <input type="text" placeholder="Doe" v-model="userdata.last_name" name="lastname" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                        </div>
                </div>

                <div class="w-full flex items-center justify-between px-6 pt-4 text-black">
                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="mail" class="font-light" >Email<span class="text-[#f44545]">*</span></label>
                            <input type="email" v-model="userdata.email" name="name" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none" placeholder="john@gmail.com">
                        </div>

                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="tel" class="font-light" >Contact<span class="text-[#f44545]">*</span></label>
                            <input type="tel" placeholder="0088776655" v-model="userdata.phone" name="tel" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                        </div>
                </div>

                <div class="w-full flex items-center justify-between px-6 pt-4 text-black">
                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="sexe" class="font-light" >Sexe<span class="text-[#f44545]">*</span></label>
                            <select v-model="userdata.sexe" name="sexe" id="contrat" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                                <option value="">Choisissez le sexe</option>
                                <option value="M">Masculin</option>
                                <option value="F">Féminin</option>
                            </select>
                        </div>

                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="daten" class="font-light" >Date de naissance<span class="text-[#f44545]">*</span></label>
                            <input type="date" placeholder="" v-model="userdata.birthdate" name="daten" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                        </div>
                </div>

                <div class="w-full flex items-center justify-between px-6 pt-4 text-black">
                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="national" class="font-light" >Nationalité<span class="text-[#f44545]">*</span></label>
                            <input type="text" v-model="userdata.nationality" name="national" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none" placeholder="Ivoirienne">
                        </div>

                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="sitmat" class="font-light" >Situation matrimonial<span class="text-[#f44545]">*</span></label>
                            <select v-model="userdata.marital_status" name="sitmat" id="sitmat" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                                <option value="">Choisissez le status</option>
                                <option value="celibataire">Célibataire</option>
                                <option value="marie">Marié</option>
                                <option value="veuve">Veuve</option>
                                <option value="divorce">Divorcé</option>
                            </select>
                        </div>
                </div>

                <div class="w-full flex items-center justify-between px-6 pt-4 text-black">
                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="nbenfant" class="font-light" >Nombre d'enfant<span class="text-[#f44545]">*</span></label>
                            <input type="number" min="0" v-model="userdata.children_nb" name="nbenfant" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none" placeholder="">
                        </div>

                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="Adresse" class="font-light" >Adresse<span class="text-[#f44545]">*</span></label>
                            <input type="text" placeholder="Ci" v-model="userdata.address" name="Adresse" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                        </div>
                </div>
            </div>
            <div class="flex flex-col items-center w-[65%]">
                <h3 class="w-full underline mt-8 mb-4 text-[20px] font-light">Poste & Contrat</h3>
                <div class="w-full flex items-center justify-between px-6 pt-4 text-black">
                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="Matricule" class="font-light" >Matricule<span class="text-[#f44545]">*</span></label>
                            <input type="text" v-model="userdata.matricule" name="Matricule" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none" placeholder="">
                        </div>

                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="Département" class="font-light" >Profil<span class="text-[#f44545]">*</span></label>
                            <select v-model="profildata.profile_id" name="Département" id="Département" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                                <option value="">Choisissez le profil</option>
                                <option v-for="value in profils" :key="value.id" :value="value.id">{{ value.label }}</option>
                            </select>
                        </div>
                </div>
                <div class="w-full flex items-center justify-between px-6 pt-4 text-black">
                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="cont" class="font-light" >Type de contrat<span class="text-[#f44545]">*</span></label>
                            <select v-model="profildata.contract_type" name="cont" id="cont" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                                <option value="STAGE">STAGE</option>
                                <option value="CDD">CDD</option>
                                <option value="CDI">CDI</option>
                                <option value="CONSULTANT">CONSULTANT</option>
                            </select>
                        </div>

                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="Début" class="font-light" >Début<span class="text-[#f44545]">*</span></label>
                            <input type="date" placeholder="" v-model="profildata.start" name="Début" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                        </div>
                </div>
                <div class="w-full flex items-center justify-between px-6 pt-4 text-black">
                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="Fin" class="font-light" >Fin<span class="text-[#f44545]">*</span></label>
                            <input type="date" v-model="profildata.end" name="Fin" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none" placeholder="">
                        </div>

                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="pro" class="font-light" >Poste<span class="text-[#f44545]">*</span></label>
                            <input type="text" placeholder="" v-model="profildata.job_name" name="pro" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                        </div>
                </div>
                <div class="w-full flex items-center justify-between px-6 pt-4 text-black">
                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="base_salary" class="font-light" >Salaire de base<span class="text-[#f44545]">*</span></label>
                            <input type="number" min="0" v-model="profildata.salary" name="base_salary" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                        </div>

                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="SurSalaire" class="font-light" >SurSalaire<span class="text-[#f44545]">*</span></label>
                            <input type="number" min="0" v-model="profildata.sursalaire" name="SurSalaire" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                        </div>
                </div>
                <div class="w-full flex items-center justify-between px-6 pt-4 text-black">
                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="transport" class="font-light" >Prime de transport<span class="text-[#f44545]">*</span></label>
                            <input type="number" min="0" v-model="profildata.prime_tp" name="transport" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                        </div>
                </div>
                <div class="w-full flex items-center justify-between px-6 pt-4 text-black">
                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="respon" class="font-light" >Prime de responsabilité<span class="text-[#f44545]">*</span></label>
                            <input type="number" min="0" v-model="profildata.prime_respo" name="respon" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                        </div>

                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="spe" class="font-light" >Prime de spéciale<span class="text-[#f44545]">*</span></label>
                            <input type="number" min="0" v-model="profildata.prime_speciale" name="spe" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                        </div>
                </div>
                <div class="w-full flex items-center justify-between px-6 pt-4 text-black">
                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="logement" class="font-light" >Prime de logement<span class="text-[#f44545]">*</span></label>
                            <input type="number" min="0" v-model="profildata.prime_logement" name="logement" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                        </div>
                </div>

                <div class="w-full flex items-center justify-between px-6 pt-4 text-black">
                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="shift" class="font-light" >Horaire<span class="text-[#f44545]">*</span></label>
                            <select v-model="userdata.shift" name="shift" id="shift" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                                <option v-for="shift in shifts" :key="shift.id" :value="shift.symbol">{{ shift.label }} : {{ shift.hour_start }} - {{ shift.hour_end }}</option>
                            </select>
                        </div>
                </div>
            </div>

            <div class="flex flex-col items-center w-[65%]">
                <h3 class="w-full underline mt-8 mb-4 text-[20px] font-light">Banque & Administration</h3>
                <div class="w-full flex items-center justify-between px-6 pt-4 text-black">
                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="cnps" class="font-light" >Numéro Cnps<span class="text-[#f44545]">*</span></label>
                            <input type="text" v-model="userdata.n_cnps" name="name" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none" placeholder="">
                        </div>

                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="rib" class="font-light" >Rib<span class="text-[#f44545]">*</span></label>
                            <input type="text" placeholder="" v-model="userdata.rib" name="rib" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                        </div>
                </div>

                <div class="w-full flex items-center justify-between px-6 pt-4 text-black">
                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="swift" class="font-light" >Swift<span class="text-[#f44545]">*</span></label>
                            <input type="text" v-model="userdata.swift" name="swift" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none" placeholder="">
                        </div>

                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="banque" class="font-light" >Banque<span class="text-[#f44545]">*</span></label>
                            <input type="text" placeholder="" v-model="userdata.bank" name="banque" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                        </div>
                </div>
            </div>
            
            <div class="flex flex-col items-center w-[65%]">
                <h3 class="w-full underline mt-8 mb-4 text-[20px] font-light">Compléments & Urgence</h3>
                <div class="w-full flex items-center justify-between px-6 pt-4 text-black">
                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="urgence" class="font-light" >Contacte cas d'urgence<span class="text-[#f44545]">*</span></label>
                            <input type="tel" v-model="userdata.emergency_phone" name="urgence" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none" placeholder="0000000000">
                        </div>

                        <div class="w-[49%] flex flex-col items-start ">
                            <label for="local" class="font-light" >Local ou expatrié<span class="text-[#f44545]">*</span></label>
                            <select v-model="profildata.employee_status" name="local" id="local" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                                <option value="LOCAL">LOCAL</option>
                                <option value="EXPATRIÉ">EXPATRIÉ</option>
                            </select>
                        </div>
                </div>
            </div>

            <button v-on:click="createUser" class="h-[45px] w-[63%] my-5 rounded-lg flex items-center justify-center text-white bg-[#5357ec]">
                <Loader2 v-if="load" class="animate-spin mx-auto"/>
                <span v-if="!load">Enregistrer</span>
            </button>
        </div> -->
    </div>
</template>
<script>
import API from "@/service/API";
import {ArrowLeft,ArrowRight,Loader2} from "lucide-vue-next"
import Swal from "sweetalert2";
// import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import gsap from "gsap";
import * as CountryData from 'country-flags-svg-v2';
console.log('Données du package importées :', CountryData);
const countries = CountryData.countries || CountryData.default.countries;

const getNationalityOptions = () => {
    if (!Array.isArray(countries)) {
     console.error("L'objet 'countries' n'est pas un tableau. Vérifiez l'importation.");
     return [];
    }
    return countries
        .filter(c => c.demonym) 
        .map(country => ({
        value: country.demonym, 
        label: country.name, 
        flag: country.flag, 
        }))
        .sort((a, b) => a.label.localeCompare(b.label));
};

export default {
    name: "AddNewUser",
    components:{
        Loader2,
        ArrowLeft,
        ArrowRight
    },
    data(){
        return {
            profils:[],
            shifts:[],
            step:1,
            load:false,
            nationalityOptions: getNationalityOptions(),
            userdata:{
                first_name:null,
                last_name: null,
                matricule:null,
                birthdate: null,
                sexe:"",
                phone:null,
                email:null,
                age_range:null,
                seniority_range:null,
                address:null,
                nationality:"",
                marital_status:"",
                children_nb:null,
                emergency_phone:null,
                rib:null,
                swift:"",
                bank:null,
                n_cnps:null,
                shift:""
            },
            profildata:{
                profile_id:null,
                start:null,
                end:null,
                salary:null,
                contract_type:"",
                job_name:null,
                sursalaire:null,
                prime_tp:null,
                prime_respo:null,
                prime_speciale:null,
                prime_logement:null,
                employee_status:"",
            }
        }
    },
    mounted(){
        this.getAllProfil();
        this.getData()
    },
    methods:{
        getAllProfil(){
            API.get("getAllProfiles")
            .then((res)=>{
                if(res.data.status){
                    this.profils = res.data.data;
                }
            })
            .catch()
        },
        getData() {
            API.get('shifts')
                .then((res) => {
                    this.shifts = res.data.data
                })
                .catch((error) => {
                    console.error(error)
                })
        },
        prev(){
            this.step -= 1;
        },
        skip(){
            if(this.step <= 3) {
                this.step += 1;
                return;
            }
            this.createUser();
        },
        async createUser(){
            this.load = true;
            try {
                const res = await API.post("auth/signup",this.userdata)
                if(!res.data.status) throw new Error(res.data.message);
                const id = res.data.data.id;
                const response = await API.post("/user_profiles",{...this.profildata,user_id:id,status:"ACTIVE"});
                if(!response.data.status) throw new Error(response.data.message);
                Swal.fire('Succès','Utilisateur enregistré avec succès','succes');
            } catch (error) {
                Swal.fire('Erreur!!!!',error?.message,'error')
            }finally{
                this.load = false;
            }
        },
        onEnter(el, done) {
            gsap.fromTo(el,
                {
                opacity: 0,
                filter: 'blur(2px)',
                },
                {
                    opacity: 1,
                    filter: 'blur(0px)',
                    duration: 0.15,
                    delay: 0.1,
                    onComplete: done,
                }
            );
        },
        onLeave(el, done) {
            gsap.to(el, {
                opacity: 0,
                filter: 'blur(2px)',
                duration: 0.15,
                onComplete: done,
            });
        },
        pushback(){
            this.$router.go(-1);
        }
    }
}
</script>